import IndividualDevelopmentPlanDetailView from './component';
import { IdpStatus } from 'components/IndividualDevelopmentPlanStatus';
import { accessors as idpAccessors } from 'data/IndividualDevelopmentPlans';
import Privileges from 'domain/Privileges';
import { PrivilegeChecker, ApiCall } from 'omni-common-ui';
import { List } from 'immutable';
import ViewNav from '../ViewNav';
import StudentSelect from '../StudentSelect';
import { actions as Group } from 'containers/Group';
import { SHOW_EXPORT, SHOW_EXPORT_LANGUAGE } from './exportFlags';

export { SHOW_EXPORT, SHOW_EXPORT_LANGUAGE };

export const Modes = {
  SUBMIT: 'submit',
  EXPORT: 'export',
  EDIT_COMMENTS: 'edit-comments',
  EDIT_STUDY_PLAN: 'edit-study-plan',
  EDIT_OVERALL_DEVELOPMENT: 'edit-overall-development',
};

function isOverallDevelopmentCompleted(template, results) {
  return template &&
    results &&
    results.items.size > 0 &&
    (template.strengths.some((st) => st.items.size > 0) ?
      results.items.filter((result) => result.typeCode === 'ST').size > 0 :
      true) &&
      (template.improvementsModes.some(
        // (st) => st.items.size > 0) ?
        (st) => st.items.filter((od) => ! results.items.some((ri) => od.unitId === ri.unitId && ri.typeCode === 'NA' && od.id === ri.subSkillId)).size > 0) ?
      results.items.filter((result) => result.typeCode === 'IM').size > 0 :
      true) &&
    (template.needAttentions.some(
      (st) => st.items.filter((od) => ! results.items.some((ri) => od.unitId === ri.unitId && ri.typeCode === 'IM' && od.id === ri.subSkillId)).size > 0) ?
      results.items.filter((result) => result.typeCode === 'NA').size > 0 :
      true);
}

const shouldDisableSubmit = (getState, props) => {
  const { groupIdpId, studentId, mode } = props.params;

  const idpId = idpAccessors.getIdpId(getState(), groupIdpId, studentId);
  const idpStatus = idpAccessors.getIdpStatus(getState(), idpId);

  return  Modes.SUBMIT === mode ||
    Modes.EDIT_COMMENTS === mode ||
    ! idpStatus ||  idpStatus.toLowerCase() !== IdpStatus.READY.toLowerCase() ||
    isAnyApiCallSaving(getState());
};

const shouldDisableExport = (props) =>
  props.params.mode === Modes.EXPORT;

const actionButtons = (getState) => ({
  Submit: {
    isPrimary: true,
    route: './submit',
    disableWhen: (props) => shouldDisableSubmit(getState, props),
    visibleWhen: ({ params }) => PrivilegeChecker.hasPrivilege(
      getState(), Privileges.IndividualDevelopmentPlan.Manage) &&
      ! Group.isDisabledReportActions(getState(), params.groupId),
  },
  Export: {
    isPrimary: false,
    route: './export',
    disableWhen: (props) => shouldDisableExport(props),
    visibleWhen: () => SHOW_EXPORT && PrivilegeChecker.hasPrivilege(
        getState(), Privileges.IndividualDevelopmentPlan.Manage),
  },
});

export default ({ getState }) => ({
  appBars: {
    sticky: {
      'student-select': {
        component: StudentSelect,
        order: 1,
      },
      'view-nav': {
        component: ViewNav,
        props: {
          hideExpandable: true,
        },
        order: 2,
      },
    },
  },
  path: ':groupIdpId/student/:studentId(/:mode)',
  component: IndividualDevelopmentPlanDetailView,
  canAccess: (props) => {
    if (! IndividualDevelopmentPlanDetailView.isInEditCommentsMode(props) &&
      ! IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode(props) &&
      ! IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode(props)) return true;

    return PrivilegeChecker.hasPrivilege(getState(), Privileges.IndividualDevelopmentPlan.Manage);
  },
  breadcrumbLabels: 'student report',
  actionButtons: {
    default: actionButtons(getState),
    [Modes.SUBMIT]: actionButtons(getState),
    [Modes.EDIT_COMMENTS]: actionButtons(getState),
    [Modes.EDIT_STUDY_PLAN]: actionButtons(getState),
    [Modes.EDIT_OVERALL_DEVELOPMENT]: actionButtons(getState),
    [Modes.EXPORT]: actionButtons(getState),
  },
});

function isAnyApiCallSaving(state) {
  return !! (state.get('apiCalls') || new List())
    .filter((call, key) =>
      ['PUT', 'POST', 'DELETE'].some((method) => key.startsWith(method)))
        .find((call) => ApiCall.State.isLoading(call));
}



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/routes.js